import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PermissionDTO {
  value: string;
  description: string;
  global: boolean;
}

export interface WrapperResponseListPermissionDTO {
  ok: boolean;
  code: number;
  message: string;
  metadata?: unknown;
  body: PermissionDTO[];
}

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getPermissions(): Observable<WrapperResponseListPermissionDTO> {
    return this.http.get<WrapperResponseListPermissionDTO>(`${this.apiUrl}/permissions`);
  }
}
